<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :fill="pathFill"
    height="35"
    width="40"
    viewBox="-51.2 -51.2 614.40 614.40"
    xml:space="preserve"
  >
    <g stroke-width="0">
      <rect x="120" y="20" width="275" height="470" rx="0" :fill="bgFill" />
    </g>

    <g stroke-linecap="round" stroke-linejoin="round" />

    <g>
      <g>
        <g>
          <path
            d="M302.933,42.667h-51.2c-7.074,0-12.8,5.726-12.8,12.8s5.726,12.8,12.8,12.8h51.2c7.074,0,12.8-5.726,12.8-12.8 S310.007,42.667,302.933,42.667z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M358.4,0H153.6c-28.228,0-51.2,22.972-51.2,51.2v409.6c0,28.228,22.972,51.2,51.2,51.2h204.8 c28.228,0,51.2-22.972,51.2-51.2V51.2C409.6,22.972,386.628,0,358.4,0z M384,460.8c0,14.14-11.46,25.6-25.6,25.6H153.6 c-14.14,0-25.6-11.46-25.6-25.6V51.2c0-14.14,11.46-25.6,25.6-25.6h204.8c14.14,0,25.6,11.46,25.6,25.6V460.8z"
          />
        </g>
      </g>
      <g>
        <g><circle cx="256" cy="443.733" r="25.6" /></g>
      </g>
      <g>
        <g><circle cx="209.067" cy="55.467" r="12.8" /></g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#F2F3F5',
    },
    bgFill: {
      type: String,
      default: '#F2F3F5',
    },
  },
};
</script>
